<template>
    <div v-if="conteudo && conteudo.equipe">
        <div class="form-row" v-for="(equipe, iex) in conteudo.equipe" :key="iex">
            <div class="col col-12 col-md-3">
                <az-input
                    class="ml-3"
                    type="select"
                    optionsMode="json"
                    :optionsList="graus"
                    sizing="sm"
                    placeholder="Grau de Participação..."
                    optionsData="id_grau_participacao"
                    v-model="equipe.id_grau_participacao">
                    <template v-slot:button-pre>
                        <div class="input-group-prepend">
                            <button class="btn btn-outline-danger" type="button" id="button-addon2"
                                title="Remover membro da equipe."
                                @click="remover_item(iex)">
                                <i class="fas fa-minus fa-fw"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
            <template v-if="equipe.id_grau_participacao">
                <div class="col col-12 col-md-3">
                    <az-input
                        placeholder="Profissional..."
                        sizing="sm"
                        type="select"
                        optionsMode="aql"
                        optionsData="id_pessoa"
                        service="medicos.index"
                        :optionsName="'medicos.index' + ( equipe.id_grau_participacao == 7 ? '.anest' : '' )"
                        :optionsParm=" { anestesista: ( equipe.id_grau_participacao == 7 ) }"
                        required
                        :validate="validate"
                        v-model="equipe.id_medico" />
                </div>
                <div class="col col-12 col-md-3" v-if="1==0">
                    <az-input
                        sizing="sm"
                        placeholder="Especialidade..."
                        type="select"
                        :optionsList="especialidades_equipe(equipe)"
                        optionsData="id"
                        required
                        :validate="validate"
                        :edicao="!consultorio"
                        v-model="equipe.id_especialidade" />
                </div>
                <div class="col col-12 col-md-2">
                    <az-input
                        icon="fa-solid fa-brazilian-real-sign fa-fw"
                        sizing="sm"
                        placeholder="Valor"
                        type="text"
                        :edicao="false"
                        :value="$util.formatMoeda(equipe.dc_valor)"
                        v-if="equipe.dc_valor && equipe.dc_valor > 0">
                        <!--
                        <template v-slot:buttonposb>
                            <div class="input-group-append" v-if="equipe.id_grau_participacao != 7 && proc.in_quantidade > 1">
                                <span class="input-group-text" id="basic-addon2">
                                    <i class="fas fa-equals mr-2"></i>
                                    {{ $util.formatMoeda(equipe.dc_valor * proc.in_quantidade) }}
                                </span>
                            </div>
                        </template>
                        -->
                    </az-input>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            conteudo: null, 
        }
    },

    computed: { 
        lista_graus (proc) {
            if ( !this.graus )
                return [];

            let lista = this.graus.filter(item => item.id_grau_participacao > 1)
                .filter(item => ( ( proc.item_tabela && proc.item_tabela.in_numero_auxiliares ) ? item.id_grau_participacao - 1 <= proc.item_tabela.in_numero_auxiliares : false )
                    || ( item.id_grau_participacao > 5 && this.is_cirurgia )
                    || ( item.id_grau_participacao == 7 && proc.item_tabela.dc_valor_anest > 0 ) );

            return lista;
        },
    },

    components: { 
        AzInput,
    },

    props: ['value', 'graus', 'validate'], 

    methods: { 
        remover_item(index) {
            this.value.equipe.splice(index, 1);
        },
    }
}
</script>
